<template>
    <div class="row stage-steps">
        <div class="col-12" v-if="journey">
            <stage-item v-for="(step, index) in journey.depart.steps"
                :key="index"
                :step="step"
                :icon="getSVGCircledIconNameByTransportMode(step.type)"
                :showLink="true"
                @showDetails="showDetails(step, index)"
                ></stage-item>
                <custom-stage-item :time="journey.depart.arrival_at" title="Arrive at destination"></custom-stage-item>
            <custom-stage-item :time="searchQuery ? searchQuery.arrive_at_time : ''" title="Attend appointment" :text="journey.appointment_length_label"></custom-stage-item>
            <div v-if="journey.return">
                <stage-item v-for="(step, index) in journey.return.steps"
                    :key="index + journey.depart.steps.length"
                    :step="step"
                    :icon="getSVGCircledIconNameByTransportMode(step.type)"
                    :showLink="true"
                    @showDetails="showDetails(step, index + journey.depart.steps.length)"
                    ></stage-item>
                <custom-stage-item :time="journey.return.arrival_at" title="Return home"></custom-stage-item>
            </div>
        </div>
    </div>
</template>
<script>
import StageItem from '@/components/StageItem.vue'
import CustomStageItem from '@/components/CustomStageItem.vue'
import { mapState, mapGetters } from 'vuex'


export default {
    props: ['journey', 'selectedTime'],
    components: {
        StageItem,
        CustomStageItem,
    },
    data() {
        return {
            timeText: '',
        }
    },
    mounted() {
        console.log(this)
    },
    computed: {
        ...mapGetters([
            'getSVGCircledIconNameByTransportMode',
        ]),
        ...mapState([
            'searchQuery',
        ]),
    },
    methods: {
        showDetails(step, index) {
            this.$emit('showDetails', step, index)
        },
    },
}
</script>
